import { render, staticRenderFns } from "./CategoriesBlock.vue?vue&type=template&id=9ec4049a&"
import script from "./CategoriesBlock.js?vue&type=script&lang=js&"
export * from "./CategoriesBlock.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports